import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { statusDiscount, withLoading } from "../../../../../../utils";
import { editDiscount } from "../../../../../../utils";
import { listDiscounts } from "../../../../../../utils";
import { listMemberships } from "../../../../../../utils";
import { deleteDiscount } from "../../../../../../utils";
import {
  Grid, Button, CircularProgress,
  Menu, MenuItem, Container, useMediaQuery, Typography
} from "@material-ui/core";
import GeneralDialog from "../../../../../GeneralDialog/GeneralDialog";
import { sizing } from '@material-ui/system';
import { CEllipsisIcon } from "../../../../../Icons/Icons";
import moment from "moment";
import StatusTag from "./../../../../../TagComponents/StatusTag";
import Form from "../../../../../Form/Form";
import notEmpty from "../../../../../../FormValidation/notEmpty";
import noWhiteSpace from "../../../../../../FormValidation/noWhiteSpace";
import { futureDate } from "../../../../../../FormValidation/validDate";
import CModal from "../../../../../Form/CModal";
import CDisplayArea from "../../../../../Form/CDisplayArea";
import LightTooltip from "../../../../../Form/LightTooltip";
import positive from "../../../../../../FormValidation/positive";

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    width: "100%",
    paddingLeft: "50px",
    paddingRight: "50px",
    paddingTop: "15px",
  },
  mobilePadding: {
    width: "100%",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingTop: "10px",
  },
  topBlock: {
    paddingBottom: "15px",
  },
  recordRow: {
    paddingLeft: "5px",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingRoght: "5px",
    width: "550px"
  },
  headingWrapper: {
    paddingBottom: "10px",
    boxShadow: "inset 0 -1px #e3e8ee",
  },
  rightElem: {
    float: "right",
  },
  rightElemPad: {
    float: "right",
    marginRight: "10px",
  },
  topHeading: {
    fontSize: "13px",
    color: "#1a1f36",
  },
  topHeadingOne: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#1a1f36",
  },
  mobileTopHeadingTwo: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#1a1f36",
  },
  topHeadingTwo: {
    fontSize: "28px",
    fontWeight: "light",
    color: "#1a1f36",
  },
  topHeadingThree: {
    backgroundColor: "#eb5757",
    opacity: "50%",
    paddingLeft: "15px",
    paddingRight: "15px",
    borderRadius: "2px",
    marginLeft: "10px",
    position: "absolute",
    marginTop: "6px",
    paddingTop: "2px",
    paddingBottom: "2px",
    fontSize: "14px",
  },
  topHeadingFour: {
    paddingLeft: "15px",
    paddingRight: "15px",
    borderRadius: "2px",
    marginLeft: "10px",
    position: "absolute",
    marginTop: "6px",
    paddingTop: "2px",
    paddingBottom: "2px",
    fontSize: "14px",
  },
  buttonBasic: {
    backgroundColor: "#ffffff",
    color: "#1a1f36",
    fontSize: "14px",
    boxShadow:
      " 0 0 0 1px rgb(42 47 69 / 10%), 0 2px 5px 0 rgb(42 47 69 / 10%), 0 1px 1.5px 0 rgb(0 0 0 / 7%), 0 1px 2px 0 rgb(0 0 0 / 8%), 0 0 0 0 transparent",
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingTop: "3px",
    paddingBottom: "3px",
    textTransform: "none",
  },
  contentRow: {
    paddingTop: "15px",
    paddingBottom: "25px",
  },
  contentColumnFirst: {
    paddingRight: "20px",
    boxShadow: "inset -1px 0 #e3e8ee",
    display: "inline-block",
  },
  contentColumnMiddle: {
    boxShadow: "inset -1px 0 #e3e8ee",
    paddingLeft: "20px",
    paddingRight: "20px",
    display: "inline-block",
  },
  contentColumnLast: {
    paddingLeft: "20px",
    display: "inline-block",
  },
  labelText: {
    fontSize: "14px",
    color: "#697386",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  valueText: {
    fontSize: "14px",
    color: "#1a1f36",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  valueText2: {
    fontSize: "14px",
    color: "#3c4257",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  valueTextNeg: {
    fontSize: "14px",
    color: "#009211",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  valueTextBG: {
    fontSize: "16px",
    color: "#1a1f36",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  valueTextBold: {
    fontSize: "14px",
    color: "#1a1f36",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  valueTextPad: {
    fontSize: "14px",
    color: "#1a1f36",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingLeft: "10px",
  },
  valueTextLink: {
    fontSize: "14px",
    color: "#3d5af1",
    cursor: "pointer",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  errorText: {
    fontSize: "14px",
    color: "#ff0000",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  blockLabel: {
    paddingTop: "10px",
    paddingBottom: "5px",
  },
  blockText: {
    paddingLeft: "10px",
  },
  subHeading: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#1a1f36",
  },
  fieldRows: {
    paddingTop: "8px",
    paddingLeft: "10px",
  },
  fieldColumnOne: {
    width: "100px",
    display: "inline-block",
  },
  fieldColumnTwo: {
    display: "inline-block",
  },
  sdCustomCellOne: {
    border: "none",
    width: "10%",
    maxWidth: "200px",
    padding: "10px",
  },
  sdCustomCellTwo: {
    border: "none",
    width: "25%",
    maxWidth: "300px",
    padding: "10px",
  },
  sdCustomCellThree: {
    border: "none",
    width: "10%",
    maxWidth: "200px",
    padding: "10px",
  },
  sdCustomCellFour: {
    border: "none",
    padding: "10px",
  },
  headerPadding: {
    padding: "10px",
  },
  bottomSpacer: {
    height: "50px",
  },
  topMarginBlock: {
    marginTop: "10px",
  },
  loaderWrapper: {
    width: "100%",
    height: "calc(100vh - 64px)"
  },
  loaderMain: {
    position: "absolute",
    top: "50%",
    left: "50%"
  },
  formContainer: {
    border: '20px',
    backgroundColor: 'white',
    borderRadius: '4px',
    padding: "20px",
    maxWidth: "600px"
  }
}));

const Discount = () => {
  const classes = useStyles();
  const [_, updateState] = useState(0);
  const dispatch = useDispatch();
  const history = useHistory();
  const small = useMediaQuery('(min-width: 750px)');
  const large = useMediaQuery('(min-width: 960px)');
  const discountDetails = useSelector((state) => {
    return state.discountDetails;
  });
  const businessId = useSelector((state) => {
    return state.buisnessDetails.businessId;
  });
  const [eOpen, setEOpen] = useState(false);
  const [aDOpen, setADOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(false);
  const [membershipChoices, setMembershipChoices] = useState([]);
  const handleClose = () => {
    setEOpen(false);
    setADOpen(false);
  };
  const handleMenuClose = () => {
    setAnchorEl(false);
  };
  const processMembershipNames = (membershipNameData) => {
    return membershipNameData.map((memberships) => {
      let {
        name,
        membershipId,
        isActive
      } = memberships;

      let id = membershipId;

      return {
        id,
        isActive,
        name
      };
    });
  };
  const getMembershipNames = async () => {
    let names = await listMemberships({
      businessId: businessId
    });
    if (names && names.membershipsDetails) {
      setMembershipChoices(processMembershipNames(names.membershipsDetails));
    }
  }
  const editFormFields = () => {
    if (discountDetails.type === "Early Bird") {
      return ([
        {
          type: "TextField",
          validator: [notEmpty, noWhiteSpace],
          initialvalue: discountDetails.name,
          label: "Name",
          name: "name",
        },
        {
          type: "Percent",
          label: "Percent",
          validator: [notEmpty, positive],
          initialvalue: discountDetails.percentage,
          name: "percent",
          numberProps: {
            decimalScale: 1
          }
        },
        {
          type: "Date",
          initialvalue: discountDetails.endDate,
          validator: [notEmpty, futureDate],
          label: "New End Date",
          name: "date",
        },
        {
          type: "TextArea",
          initialvalue: discountDetails.description,
          label: "Description (optional)",
          name: "description",
          resizeEnabled: false,
          moreProps: {
            rowsMin: 4,
            rowsMax: 10
          }
        }
      ]);
    } if (discountDetails.type === "Membership") {
      return ([
        {
          type: "TextField",
          validator: [notEmpty, noWhiteSpace],
          initialvalue: discountDetails.name,
          label: "Name",
          name: "name",
        },
        {
          type: "Percent",
          label: "Percent",
          validator: [notEmpty, positive],
          initialvalue: discountDetails.percentage,
          name: "percent",
          numberProps: {
            decimalScale: 1
          }
        },
        {
          type: "SingleSelect",
          label: "Membership",
          choices: membershipChoices.filter(choice => choice.isActive === true).map((choices) => {
            return choices.isActive && [
              choices.name, choices.id
            ];
          }),
          name: "membership",
          validator: value => (value === null ? "Cannot be empty" : null),
          initialvalue: discountDetails.membershipId
        },
        {
          type: "TextArea",
          initialvalue: discountDetails.description,
          label: "Description (optional)",
          name: "description",
          resizeEnabled: false,
          moreProps: {
            rowsMin: 4,
            rowsMax: 10
          }
        }
      ]);
    } else {
      return ([
        {
          type: "TextField",
          validator: [notEmpty, noWhiteSpace],
          initialvalue: discountDetails.name,
          label: "Name",
          name: "name",
        },
        {
          type: "Percent",
          label: "Percent",
          validator: [notEmpty, positive],
          initialvalue: discountDetails.percentage,
          name: "percent",
          numberProps: {
            decimalScale: 1
          }
        },
        {
          type: "TextArea",
          initialvalue: discountDetails.description,
          label: "Description (optional)",
          name: "description",
          resizeEnabled: false,
          moreProps: {
            rowsMin: 4,
            rowsMax: 10
          }
        }
      ]);
    };
  };
  async function handleSubmit(event) {

    dispatch({
      type: 'UPDATE', payload: {
        loading: true
      }
    });
    let success = await editDiscount({
      businessId: businessId,
      discountId: discountDetails.discountId,
      name: event.name,
      percentage: event.percent,
      membershipId: event.membership ? event.membership : null,
      endDate: event.date ? event.date : null,
      description: event.description ? event.description : null
    })
    dispatch({
      type: 'UPDATE', payload: {
        loading: false
      }
    });
    if (success) {
      updateState((_) => !_);
    }
  };
  async function handleClick(event) {

    let success = await withLoading(statusDiscount, {
      businessId: businessId,
      discountId: discountDetails.discountId,
      isActive: discountDetails.isActive ? false : true,
    })

    if (success) {
      setADOpen(false);
      updateState((_) => !_);

    }
  }

  const { discountIdURL } = useParams();
  const discMem = () => {
    if (discountDetails.type === "Membership") {
      let item = membershipChoices.find(m => m.name === discountDetails.membershipName);
      return item ? item.isActive : !discountDetails.isActive;
    } else {
      return (true);
    }
  }

  useEffect(async () => {
    dispatch({
      type: "UPDATE",
      payload: {
        loading: true,
      },
    });

    let data = await listDiscounts({
      businessId: businessId,
      discountId: discountIdURL,
    });
    await getMembershipNames();

    dispatch({
      type: "UPDATE",
      payload: {
        loading: false,
        discountDetails: data ? data.discountDetails[0] : null,
      },
    });
  }, [_]);

  if (discountDetails && discountDetails.discountId == discountIdURL) {
    return (
      <Grid container className={large ? classes.mainWrapper : classes.mobilePadding}>
        <React.Fragment>
          <CModal open={eOpen} setOpen={setEOpen}
            children={
              <Container component="main" className={classes.formContainer}>
                <Form
                  action={handleSubmit}
                  postAction={handleClose}
                  title="Edit Discount"
                  cancelEnabled
                  cancelAction={handleClose}
                  cancelText="Cancel"
                  submitText="Save"
                  inputFields={editFormFields()}
                >
                </Form>
              </Container>
            }
          />
          <GeneralDialog
            open={aDOpen}
            close={handleClose}
            title={discountDetails.isActive ? "Deactivate Discount" : "Activate Discount"}
            text={discountDetails.isActive ? "Are you sure you want to deactivate this discount?" : "Are you sure you want to activate this discount?"}
            action={handleClick}
          />
          <GeneralDialog
            open={deleteOpen}
            close={() => { setDeleteOpen(false) }}
            title="Delete Discount"
            text="Are you sure you want to delete this discount parmanently."
            action={async () => {
              let success = await withLoading(deleteDiscount, {
                businessId: businessId,
                discountId: discountDetails.discountId
              })
              if (success && success.error == false) {
                history.replace(`/dashboard/${businessId}/Discounts`);
              }

            }}
          />
        </React.Fragment>
        <Grid container item xs={12} direction="row">
          <Grid item xs={discMem() ? 6 : 12}>
            <div className={classes.topBlock}>
              <span className={classes.topHeading}>DISCOUNT</span>
            </div>
          </Grid>
          {discMem() ? <Grid item xs={6}>
            <div className={classes.topBlock}>
              <span className={classes.rightElem}>
                <Button onClick={(event) => { setAnchorEl(event.currentTarget); }} className={classes.buttonBasic}><CEllipsisIcon /></Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  getContentAnchorEl={null}
                  keepMounted
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                >
                  <MenuItem onClick={discMem() ? () => { setEOpen(true); handleMenuClose(); } : ''}>Edit</MenuItem>
                  <MenuItem onClick={() => { setADOpen(true); handleMenuClose(); }}>{discountDetails.isActive ? "Deactivate" : "Activate"}</MenuItem>
                  {!discountDetails.isActive ?
                    <MenuItem onClick={() => { setDeleteOpen(true); setAnchorEl(false) }}>
                      <Typography >
                        Delete Discount
                      </Typography>
                    </MenuItem> : null}
                </Menu>
              </span>
            </div>
          </Grid> : null}
        </Grid>
        <Grid container item direction="row" xs={12} spacing={small ? 2 : 0} style={{ width: "100%" }}>
          <Grid item style={(small ? { maxWidth: "50%" } : { width: "100%" })}>
            <div className={classes.headerPadding} style={{ marginLeft: -10 }}>
              <LightTooltip title={discountDetails.name} arrow>
                <Typography className={small ? classes.topHeadingOne : classes.mobileTopHeadingTwo} noWrap style={{ width: `calc(100%)` }}>
                  {discountDetails.name}
                </Typography>
              </LightTooltip>
            </div>
          </Grid>
          <Grid item style={small ? { paddingLeft: "20px" } : { paddingLeft: "10px" }}>
            <div className={small ? classes.headerPadding : null}>
              <span className={small ? classes.topHeadingFour : null}>
                <StatusTag wrapperName={discountDetails.isActive ? "greenWrapper" : "redWrapper"} value={discountDetails.isActive ? "Active" : "Inactive"} />
              </span>
            </div>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <div className={classes.contentRow} style={{ marginLeft: -10 }}>
            <div className={classes.fieldRows}>
              <div className={classes.fieldColumnOne}>
                <span className={classes.labelText}>Rate</span>{" "}
              </div>
              <div className={classes.fieldColumnTwo}>
                <span className={classes.valueText}>
                  {`${discountDetails.percentage}%`}
                </span>
              </div>
            </div>
            <div className={classes.fieldRows}>
              <div className={classes.fieldColumnOne}>
                <span className={classes.labelText}>Type</span>{" "}
              </div>
              <div className={classes.fieldColumnTwo}>
                <span className={classes.valueText}>
                  {discountDetails.type}
                </span>
              </div>
            </div>
            {discountDetails.type === "Early Bird" ? <div className={classes.fieldRows}>
              <div className={classes.fieldColumnOne}>
                <span className={classes.labelText}>End Date</span>{" "}
              </div>
              <div className={classes.fieldColumnTwo}>
                <span className={classes.valueText}>
                  {discountDetails.endDate}
                </span>
              </div>
            </div> : null}
            {discountDetails.type === "Membership" ? <div className={classes.fieldRows}>
              <div className={classes.fieldColumnOne}>
                <span className={classes.labelText}>Membership</span>{" "}
              </div>
              <div className={classes.fieldColumnTwo} style={{ width: `calc(70%)` }}>
                <LightTooltip title={discountDetails.membershipName} arrow>
                  <Typography noWrap className={classes.valueText} style={{ marginBottom: -5 }}>
                    {discountDetails.membershipName}
                  </Typography>
                </LightTooltip>
              </div>
            </div> : null}
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className={classes.headingWrapper}>
            <span className={classes.labelText}>Description</span>
          </div>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: "10px" }}>
          <span className={classes.valueText}>
            <CDisplayArea
              value={discountDetails.description ? discountDetails.description : null}
              initialMaxHeight={"calc(100vh - 360px)"}
            />
          </span>{" "}
        </Grid>
        <Grid item xs={12}>
          <div className={classes.bottomSpacer}></div>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid container className={classes.mainWrapper}>
        <Grid item xs={12}>
          <div className={classes.loaderWrapper}>
            <CircularProgress className={classes.loaderMain} />
          </div>
        </Grid>
      </Grid>
    );
  }
};

export default Discount;
